import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { LocationModel } from 'src/app/shared/services/models/pharmacy/location.model';
import { StorageAmountLocationStruct } from 'src/app/shared/services/structs/pharmacy/storage-amount-location.struct';
import { ProcedureSigtapStruct } from '../../services/structs/billing/procedure-sigtap.struct';

@Component({
    selector: 'app-quantity-procedure-sigtap-modal',
    templateUrl: './quantity-procedure-sigtap-modal.component.html',
    styleUrls: ['./quantity-procedure-sigtap-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QuantityProcedureSigtapModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<QuantityProcedureSigtapModalComponent>,
    private formBuilder: FormBuilder,
    private alertService: AlertService
  ) { }

  public isLoading: boolean = true;
  public cancelAttendance: boolean = false;

  public model: FormGroup;

  public listProcedureSigtap: ProcedureSigtapStruct[] = [];

  ngOnInit(): void {
    this.listProcedureSigtap = this.data.listProcedureSigtap;
    console.log("data: ", this.data)
    this.model = this.formBuilder.group({
      listProcedure: this.formBuilder.array([])
    });
    this.populateFormArray();

  }

  close() {
    this.matDialogRef.close({ listProcedureSigtap: this.listProcedureSigtap, cancelAttendance: this.cancelAttendance });
  }

  submit() {
    if (this.isLoading)
      return;

    if (!this.model.valid) {
      this.alertService.show('Erro', "Preencha todos em vermelho", AlertType.error);
      this.isLoading = false;
      return;
    }

    this.model.get('listProcedure').value.forEach((x, index) => {
      this.listProcedureSigtap[x.index].quantity = x.quantity;
    });

    this.cancelAttendance = false;
    this.close();
  }

  populateFormArray() {
    this.listProcedureSigtap.forEach((x, index) => {
      let quantity = 1;
      if (this.data.listProcedureModel && x.idProcedureSigtap) {
        const count = this.data.listProcedureModel.filter((p: any) => p.idProcedureSigtap === x.idProcedureSigtap).length;
        if (count > 0) {
          quantity = count;
        }
      }

      (this.model.controls['listProcedure'] as FormArray).push(
        this.formBuilder.group({
          index: [index],
          sigtapName: [{ value: x.procedureName, disabled: true }],
          quantity: [quantity, [Validators.required]],
        }));
    });
    console.log("model: ", (this.model.controls['listProcedure'] as FormArray))
    this.isLoading = false;
  }

  clickCancel() {
    this.cancelAttendance = true;
    this.close();
  }
}